import CustomScrollbar from 'app/components/CustomScrollbar';
import Spinner from 'app/components/Spinner';
import useFetchArticle from 'app/hooks/fetch/useFetchArticle';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import Header from '../../../../components/Header';
import { waitForIDs } from '../../../../copied/getIds';
import useSelectedIsSuggested from '../../../../hooks/analytics/useSelectedIsSuggested';
import TailorArticleView from '../../components/TailorArticleView';
import useScrollProgress from '../../hooks/useScrollProgress';
import useTailorTracking from '../../hooks/useTailorTracking';
import ArticlePageSuggestedArticle from './ArticlePageSuggestedArticle';
import { useSearch } from '../../hooks/useSearch';

export default function TailorArticle() {
  const { articleId } = useParams();
  const { data: article, isLoading } = useFetchArticle(articleId!);

  const [isSuggested] = useSelectedIsSuggested();
  const { search } = useSearch();

  const { captureArticlePageview, captureScrollProgress } = useTailorTracking();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const progress = useScrollProgress(containerRef);

  useEffect(() => {
    if (!article) return;
    waitForIDs().then(({ conditionId }) => {
      captureArticlePageview(article, {
        conditionId,
        search,
        isSuggested,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (progress > 0) {
      captureScrollProgress(progress);
    }
  }, [progress, captureScrollProgress]);

  if (isLoading) {
    return (
      <div className="grow flex justify-center mt-24">
        <Spinner />
      </div>
    );
  }

  return (
    <CustomScrollbar
      id="ostro-tailor-article-container"
      containerRef={containerRef}
      className="px-7 py-6"
    >
      <Header showIndicationSelector={false} />
      {article && <TailorArticleView article={article} />}
      <ArticlePageSuggestedArticle containerRef={containerRef} />
    </CustomScrollbar>
  );
}
